/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Focus_Pass_Page_SubtitleInputs */

const en_focus_pass_page_subtitle = /** @type {(inputs: Focus_Pass_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accumulate focus time to get new, limited "Land Styles"!`)
};

const ar_focus_pass_page_subtitle = /** @type {(inputs: Focus_Pass_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`راكم وقت التركيز لتحصل على "نمط الأرض" جديد ومحدود!`)
};

const de_focus_pass_page_subtitle = /** @type {(inputs: Focus_Pass_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sammeln Sie Fokuszeit, um neue, begrenzte "Land-Stils" zu erhalten!`)
};

const es_focus_pass_page_subtitle = /** @type {(inputs: Focus_Pass_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Acumula tiempo de concentración para conseguir nuevos "Estilos de terreno" de edición limitada!`)
};

const fr_focus_pass_page_subtitle = /** @type {(inputs: Focus_Pass_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accumulez du temps de concentration pour obtenir les nouveaux «Styles de sol» en édition limitée !`)
};

const it_focus_pass_page_subtitle = /** @type {(inputs: Focus_Pass_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accumula tempo di concentrazione per ottenere nuovi, limitati "Stili del terreno"!`)
};

const ja_focus_pass_page_subtitle = /** @type {(inputs: Focus_Pass_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集中時間を貯めて、新しい限定「ランドスタイル」を手に入れよう！`)
};

const ko_focus_pass_page_subtitle = /** @type {(inputs: Focus_Pass_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`집중 시간을 쌓아 신상 한정판 "랜드 스타일"을 획득하세요!`)
};

const pt_br_focus_pass_page_subtitle = /** @type {(inputs: Focus_Pass_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acumule tempo de foco para obter o novo "Estilo de terreno", que é por tempo limitado!`)
};

const ru_focus_pass_page_subtitle = /** @type {(inputs: Focus_Pass_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Накапливайте время фокусировки, чтобы получить новые лимитированные «Стили земли»!`)
};

const th_focus_pass_page_subtitle = /** @type {(inputs: Focus_Pass_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สะสมเวลาการโฟกัสเพื่อรับ "สไตล์พื้นดิน" ใหม่แบบลิมิเต็ด!`)
};

const tr_focus_pass_page_subtitle = /** @type {(inputs: Focus_Pass_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeni, sınırlı sayıda Arazi Türleri almak için odaklanma süresi biriktir!`)
};

const zh_cn_focus_pass_page_subtitle = /** @type {(inputs: Focus_Pass_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`累积专注时数，获得全新限定「土地皮肤」!`)
};

const zh_tw_focus_pass_page_subtitle = /** @type {(inputs: Focus_Pass_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`累積專注時數，獲得全新限定「土地造型」!`)
};

/**
* | output |
* | --- |
* | "Accumulate focus time to get new, limited \"Land Styles\"!" |
*
* @param {Focus_Pass_Page_SubtitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const focus_pass_page_subtitle = /** @type {((inputs?: Focus_Pass_Page_SubtitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Focus_Pass_Page_SubtitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_focus_pass_page_subtitle(inputs)
	if (locale === "ar") return ar_focus_pass_page_subtitle(inputs)
	if (locale === "de") return de_focus_pass_page_subtitle(inputs)
	if (locale === "es") return es_focus_pass_page_subtitle(inputs)
	if (locale === "fr") return fr_focus_pass_page_subtitle(inputs)
	if (locale === "it") return it_focus_pass_page_subtitle(inputs)
	if (locale === "ja") return ja_focus_pass_page_subtitle(inputs)
	if (locale === "ko") return ko_focus_pass_page_subtitle(inputs)
	if (locale === "pt_br") return pt_br_focus_pass_page_subtitle(inputs)
	if (locale === "ru") return ru_focus_pass_page_subtitle(inputs)
	if (locale === "th") return th_focus_pass_page_subtitle(inputs)
	if (locale === "tr") return tr_focus_pass_page_subtitle(inputs)
	if (locale === "zh_cn") return zh_cn_focus_pass_page_subtitle(inputs)
	return zh_tw_focus_pass_page_subtitle(inputs)
});